import $ from 'jquery';

import initializeNavigation from "./navigation";
import initializeNavigationMobile from "./navigation-mobile";
import initializeSwiperThemeParent from "./themenverwandt";
import initializeSwiperGallery from "./gallery";
import onWindowLoad from "./load";
import onResizeWindow from "./resize"
import productChild from "./product-child";
import question from "./question";
import reviewsSwipe from "./reviews";
import buttonETermin from "./eTermin";
import project from "./project";
import form from "./form";


$(document).ready(() => {
    initializeNavigation();
    onWindowLoad();
    initializeNavigationMobile();
    initializeSwiperThemeParent();
    onResizeWindow();
    productChild();
    initializeSwiperGallery();
    question();
    reviewsSwipe();
    buttonETermin();
    project();
    form();

});

